import { render, staticRenderFns } from "./GroupCard.vue?vue&type=template&id=11b5fb9e&scoped=true&"
import script from "./GroupCard.vue?vue&type=script&lang=js&"
export * from "./GroupCard.vue?vue&type=script&lang=js&"
import style0 from "./GroupCard.vue?vue&type=style&index=0&id=11b5fb9e&lang=scss&scoped=true&"
import style1 from "./GroupCard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b5fb9e",
  null
  
)

export default component.exports